import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { VoteWithEmailFormContainer } from './styleComponents';
import validate from './validation';
import InputModal from '../../components/Form/InputModal';
import { SubmitButton } from '../auth/Login';
import { compose } from 'react-apollo';
import loading from '../../images/loading_w.svg';
const styleLoadingAnimation = {
  height: '30px'
}

class VoteWithEmailForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sendingVote: false
    };
  }

  submitForm = (data) => {
    this.setState({ sendingVote: true });
    const { submitEmailVoting, emailPublicVote } = this.props;
    submitEmailVoting(data, emailPublicVote);
  };

  render() {
    const { handleSubmit, submitting } = this.props;
    const { sendingVote } = this.state;
    return (
      <VoteWithEmailFormContainer
        onSubmit={handleSubmit((data) => {
          this.submitForm(data);
        })}
      >
        <Field name="name" type="text" component={InputModal} label="Your name"/>
        <Field name="email" type="text" component={InputModal} label="Your email"/>
        <div className="btnContainer">
          {!sendingVote ? (<SubmitButton type="submit" disabled={submitting}>
            Submit
          </SubmitButton>) : (<><img style={styleLoadingAnimation} src={loading} alt=""/>Sending...</>)}

        </div>
      </VoteWithEmailFormContainer>
    );
  }
}

export default compose(
  reduxForm({
    form: 'emailVotingForm',
    validate
  })
)(VoteWithEmailForm);
